import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import ResetPasswordForm from './ResetPasswordForm';
var ResetPassword = function ResetPassword(_ref) {
  var status = _ref.status,
    oneTimeLoginHash = _ref.oneTimeLoginHash,
    userIdentity = _ref.userIdentity,
    resetPassword = _ref.resetPassword;
  var _useTranslate = useTranslate(),
    translationExists = _useTranslate.translationExists;
  return /*#__PURE__*/React.createElement("div", {
    className: "container login new-button-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 offset-md-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Reset your password"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, translationExists('this will reset your password for both aje and curie') ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(T, {
    source: "reset-password-message"
  }), /*#__PURE__*/React.createElement(T.md, {
    source: "this will reset your password for both aje and curie"
  })) : /*#__PURE__*/React.createElement(T.md, {
    source: "reset-password-message"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 offset-md-3"
  }, /*#__PURE__*/React.createElement(ResetPasswordForm, {
    resetPassword: resetPassword,
    oneTimeLoginHash: oneTimeLoginHash,
    processing: status.processing,
    userIdentity: userIdentity
  }))));
};
export default ResetPassword;